import { TicketTimelineApi } from './ticket-timeline.api'
import type { TicketTimeline } from './ticket-timeline.types'

/** Ticket timeline service — the fleet's /fleet/timeline API. No reactive state here. */
export function useTicketTimelineService() {
  const getTimeline = async (key: string): Promise<TicketTimeline> => {
    const timeline = await TicketTimelineApi.getTimeline(key)
    return { ...timeline, notes: timeline.notes ?? [], events: timeline.events ?? [] }
  }

  return { getTimeline }
}
